import styled from 'styled-components';

import { StandardTab, Flexbox } from '@ibinder/ui-common-core';

export const ProviderInfoTabContainer = styled(Flexbox)`
  flex-direction: row;
  border-bottom: solid 1px ${(p) => p.theme.colors.discrete20};
  padding: 0.75rem 0;
`;

export const ProviderInfoTab = styled(StandardTab)`
  width: 24%;
`;
export const ProviderInfoTabContent = styled(Flexbox)`
  padding: 0.5rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontStyles.smallFont.fontWeight};
  font-size: ${({ theme }) => theme.fontStyles.smallFont.fontSize}px;
  justify-content: center;
`;
